import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost } from '../../lib/api';

export const tenantUsersKey = (params) => ['users', 'tenant', params || {}];

export function useTenantUsers(params = {}) {
  const q = new URLSearchParams();
  if (params.q) q.set('q', params.q);
  if (params.page) q.set('page', String(params.page));
  if (params.page_size) q.set('page_size', String(params.page_size));
  const qs = q.toString();
  return useQuery({
    queryKey: tenantUsersKey(params),
    queryFn: () => apiGet(`/users${qs ? `?${qs}` : ''}`),
  });
}

export function useCreateTenantUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiPost('/users', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users', 'tenant'] }),
  });
}

export function useResetTenantUserPassword() {
  return useMutation({
    mutationFn: ({ userId, password }) =>
      apiPost(`/users/${userId}/reset-password`, { new_temporary_password: password }),
  });
}

export function useDeactivateTenantUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) => apiPost(`/users/${userId}/deactivate`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users', 'tenant'] }),
  });
}

export function useActivateTenantUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId) => apiPost(`/users/${userId}/activate`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users', 'tenant'] }),
  });
}
